import { render, staticRenderFns } from "./_profit_and_loss.vue?vue&type=template&id=ec62f248&"
import script from "./_profit_and_loss.vue?vue&type=script&lang=js&"
export * from "./_profit_and_loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports